import React, { Component } from "react";
import { EditTicketProps, EditTicketState } from "../../interfaces/ticket";
import { connect } from "react-redux";
import jwt from "jsonwebtoken";
import { secretKey } from "../../secret";
import Loader from "react-loader-spinner";
import Topbar from "../topbar/topbar";
import Sidebar from "../sidebar/sidebar";
import Select from "react-select";
import Footer from "../footer/footer";
import moment from "moment";
import CheckChanges from "../confirmOnLeave";
import { BASE_URL } from "../config/setting";
import { Link, Redirect } from "react-router-dom";
import {
    updateTicketBySupervisor,
    engineersList,
    engineersListByRole,
    subCategoryList,
    getTicket,
    statusList,
    priorityList,
    typeList,
    groupList,
    requestersList,
    updateTicketByEngineer,
    sendReply,
    getAllTicketDiscussionByTicket,
} from "../../redux/actions/ticket";
import { logoutUser } from "./../../redux/actions/user";
import config from "../config/setting";
import { extname } from "path";
import { WithContext as ReactTags } from "react-tag-input";
import "./tickets.css";
import { toast } from "react-toastify";
import { Interweave } from "interweave";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.core.css";
import "react-quill/dist/quill.snow.css";
import { isEmpty } from "lodash";
import { IMAGE_URL } from "../../client-config";

const KeyCodes = {
    comma: 188,
    enter: 13,
};
const delimiters = [KeyCodes.comma, KeyCodes.enter];
class EditTicket extends Component<EditTicketProps, EditTicketState> {
    closeModal: any;
    selectRef: any;
    selectRefCat: any;
    fileInputRef: any;
    fileInputRefReply: any;
    constructor(props: any) {
        super(props);
        this.state = {
            supervisor_file: "",
            engineer_file: "",
            priority: "",
            group: "",
            request: "",
            status: "",
            category: "",
            work_note: "",
            subCategory: "",
            assignee: [],
            replyDescription: "",
            replyFile: "",
            toRequester: "",
            toEnginner: "",
            emailFrom: "",
            requester_id: "",
            re_assign_reason: "",
            email_to_id: "",
            emailRecipents: [],
        };
        this.selectRef = null;
        this.selectRefCat = null;
        this.fileInputRef = null;
        this.fileInputRefReply = null;
        this.handleSaveBtnClick = this.handleSaveBtnClick.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDeleteTag = this.handleDeleteTag.bind(this);
        this.handleAdditionTag = this.handleAdditionTag.bind(this);
        this.handleDragTag = this.handleDragTag.bind(this);

    }
    componentDidMount() {
        let id = this.props.match.params.id;
        this.props.getTicket(id);
        this.props.priorityList();
        this.props.statusList();
        this.props.groupList();
        this.props.requestersList();
        this.props.typeList();
        this.props.getAllTicketDiscussionByTicket(id);
        document.title = "SimplexServices | Update Ticket";
    }
    handleDeleteTag(i: any) {
        const { emailRecipents } = this.state;
        this.setState({
            emailRecipents: emailRecipents.filter(
                (tag: any, index: any) => index !== i
            ),
        });
    }

    handleAdditionTag(tag: any) {
        this.setState((state) => ({
            emailRecipents: [...state.emailRecipents, tag],
        }));
    }

    handleDragTag(tag: any, currPos: any, newPos: any) {
        const tags = [...this.state.emailRecipents];
        const newTags = this.state.emailRecipents.slice();
        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);
        this.setState({ emailRecipents: newTags });
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        if (this.props.ticket !== nextProps.ticket && nextProps.ticket) {
            const ticket = nextProps.ticket;

            if (!ticket || typeof ticket !== 'object') {
                return;
            }

            // Find priority code from priority list if not directly available
            let priorityCode = ticket.ticket_priority_code || "";
            if (!priorityCode && ticket.priority_ticket_priority_description && nextProps.priority) {
                const matchedPriority = nextProps.priority.find(
                    (p: any) => p.ticket_priority_description === ticket.priority_ticket_priority_description
                );
                if (matchedPriority) {
                    priorityCode = matchedPriority.ticket_priority_code;
                }
            }

            // Extract IDs - handle both new mapped field names and raw field names for backward compatibility
            const groupId = ticket.group_id || ticket.tickets_group || ticket.group || "";
            const assigneeId = ticket.assignee_id || ticket.tickets_assignee_id || "";
            const categoryId = ticket.cat_id || ticket.tickets_cat_id || "";
            const subCategoryId = ticket.sub_category_id || ticket.tickets_sub_category || ticket.sub_category || "";
            const requesterId = ticket.requester_id || "";

            this.setState({
                status: ticket.ticket_status_code || "",
                priority: priorityCode,
                category: categoryId,
                subCategory: subCategoryId,
                group: groupId,
                request: requesterId,
                assignee: assigneeId,
                toRequester: ticket.requester_email || "",
                toEnginner: ticket.assignee_email || "",
                requester_id: requesterId,
            });

            // Load engineers for the group if group_id exists
            if (groupId) {
                this.props.engineersListByRole(groupId);
            }

            // Load subcategories for the category if cat_id exists
            if (categoryId) {
                this.props.subCategoryList(categoryId);
            }
        }
        if (sessionStorage) {
            this.setState({ emailFrom: sessionStorage.getItem("email") });
        }
    }

    handleInputChange(event: { target: { name: any; value: any } }) {
        if (event.target.value[0] == " ") {
            return;
        }
        this.setState({
            [event.target.name]: event.target.value,
        });
    }

    // rich text editor modules
    myModules = {
        toolbar: [
            [{ font: [] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ color: [] }, { background: [] }],
            [{ script: "sub" }, { script: "super" }],
            ["blockquote", "code-block"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }, { align: [] }],
            ["link", "image"],
            ["clean"],
        ],
    };

    // rich text editor on change for reply description
    handleReactQuillChange = (value: any) => {
        // Directly and unconditionally update the state for the Quill editor.
        this.setState({ replyDescription: value });
    };

    // rich text editor on change for work notes
    handleWorkNoteChange = (value: any) => {
        this.setState({ work_note: value });
    };

    handleInputChangeRequester = (e: any) => {
        this.selectRef?.select.clearValue();
        if (e && e.value > 0) {
            this.setState({ request: e.value });
        } else {
            this.setState({ request: "" });
        }
    };

    handleInputChangeGroup = (e: any) => {
        this.selectRef?.select.clearValue();
        // When changing group, reset assignee to avoid keeping a user from a different group
        // and fetch the new group's engineers for the "Assigned To" dropdown.
        if (e && e.value > 0) {
            this.setState({ group: e.value, assignee: "", toEnginner: "" });
            this.props.engineersListByRole(e.value);
        } else {
            this.setState({ group: "" });
        }
    };

    handleInputChangeCategory = (event: any) => {
        this.selectRefCat?.select.clearValue();
        if (event && event.value > 0) {
            this.setState({
                category: event.value,
                subCategory: "",
            });
            this.props.subCategoryList(event.value);
        }
    };

    handleAssigneeInputChange = (e: any) => {
        if (e && e.value > 0) {
            this.setState({ assignee: e.value });
        } else {
            this.setState({ assignee: "" });
        }
    };

    handleSubCategoryInputChange = (e: any) => {
        if (e && e.value > 0) {
            this.setState({ subCategory: e.value });
        } else {
            this.setState({ subCategory: "" });
        }
    };

    maxSelectFile = (event: any) => {
        const files = event.target.files;
        if (!files || files.length <= 5) {
            return true;
        }

        const msg = "Only 5 files can be uploaded at a time";
        event.target.value = null;
        toast.error(msg, {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true,
            autoClose: 3000,
        });
        return false;
    };

    checkFileSize = (event: any) => {
        const files = event.target.files as FileList | null;
        if (!files || files.length === 0) {
            return true;
        }

        const maxImageSize = 2 * 1024 * 1024; // 2 MB
        const maxOtherSize = 2 * 1024 * 1024; // 2 MB
        let errorMessage = "";

        for (let x = 0; x < files.length; x++) {
            const file = files[x];
            const isImage =
                (file.type && file.type.startsWith("image/")) ||
                /\.(jpe?g|png|gif|bmp|webp)$/i.test(file.name || "");

            const limit = isImage ? maxImageSize : maxOtherSize;

            if (file.size > limit) {
                if (isImage) {
                    errorMessage =
                        "Image is too large. Maximum allowed image size is 2 MB.";
                } else {
                    errorMessage =
                        "File is too large. Maximum allowed file size is 2 MB.";
                }
                break;
            }
        }

        if (!errorMessage) {
            return true;
        }

        event.target.value = null;
        toast.error(errorMessage, {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true,
            autoClose: 3000,
        });
        return false;
    };
    fileSelectedHandlerReply = (e: any) => {
        if (this.maxSelectFile(e) && this.checkFileSize(e)) {
            this.setState({ replyFile: e.target.files });
        }
    };
    isTicketReady = () => {
        const {
            group,
            category,
            subCategory,
            priority,
            status,
            assignee,
            work_note,
            request,
        } = this.state;
        const roleId = sessionStorage.getItem("role");
        const { ticket } = this.props;

        if (!ticket || !ticket.id) {
            return false;
        }

        // Prevent update if status is "Received" (status code 1)
        if (status == 1 || status === "1") {
            return false;
        }

        if (roleId === "5" || roleId === "3") {
            if (status === 5 || status === "5") {
                return work_note !== "" && work_note.trim() !== "" && status !== "" && status !== null;
            }
            return status !== "" && status !== null;
        } else if (roleId === "1") {
            const assigneeValid = Array.isArray(assignee) ? assignee.length > 0 : (assignee !== "" && assignee !== null);
            return (
                (group !== "" && group !== null) &&
                (category !== "" && category !== null) &&
                (subCategory !== "" && subCategory !== null) &&
                (priority !== "" && priority !== null) &&
                assigneeValid &&
                (status !== "" && status !== null) &&
                (request !== "" && request !== null)
            );
        } else {
            const assigneeValid = Array.isArray(assignee) ? assignee.length > 0 : (assignee !== "" && assignee !== null);
            return (
                (group !== "" && group !== null) &&
                (category !== "" && category !== null) &&
                (subCategory !== "" && subCategory !== null) &&
                (priority !== "" && priority !== null) &&
                assigneeValid &&
                (status !== "" && status !== null)
            );
        }
    };

    isReplyReady = () => {
        const { toEnginner, toRequester, replyDescription } = this.state;
        const roleId = sessionStorage.getItem("role");
        if (roleId === "3") {
            return toEnginner !== "" && replyDescription !== "";
        } else {
            return toRequester !== "" && replyDescription !== "";
        }
    };

    handleSaveBtnClick = (event: any) => {
        const {
            category,
            assignee,
            subCategory,
            engineer_file,
            request,
            work_note,
            priority,
            group,
            status,
        } = this.state;
        let id = this.props.match.params.id;
        const data: any = new FormData();
        const roleId = sessionStorage.getItem("role");

        // Check if status is "Received" (status code 1)
        if (status == 1 || status === "1") {
            toast.error("You cannot update the ticket on the received status", {
                position: toast.POSITION.TOP_CENTER,
                hideProgressBar: true,
                autoClose: 3000
            });
            event.preventDefault();
            return;
        }

        if (roleId === "5") {
            if (engineer_file) {
                for (var x = 0; x < engineer_file.length; x++) {
                    data.append("files", engineer_file[x]);
                }
            }
            data.append("work_note", work_note);
            data.append("ticket_status_code", status);
            data.append("isActive", config.ACTIVE);

            let ticketDate = moment().utc(false).format("YYYY-MM-DD HH:mm:ss");
            if (status == 1) {
                data.append("recieved_time", ticketDate);
            } else if (status == 2) {
                data.append("assigned_time", ticketDate);
            } else if (status == 3) {
                data.append("resolved_time", ticketDate);
            } else if (status == 4) {
                data.append("stop_time", ticketDate);
            } else if (status == 5) {
                data.append("closed_time", ticketDate);
            }
            this.props.updateTicketByEngineer(id, data);
        } else {
            data.append("cat_id", category);
            data.append("sub_category", subCategory);
            data.append("assignee_id", assignee);
            data.append("ticket_priority_code", priority);
            data.append("ticket_status_code", status);
            data.append("group_id", group);
            if (roleId === "1") data.append("requester_id", request);
            data.append("isActive", config.ACTIVE);
            if (engineer_file) {
                for (var x = 0; x < engineer_file.length; x++) {
                    data.append("files", engineer_file[x]);
                }
            }
            data.append("work_note", work_note);
            let ticketDate = moment().utc(false).format("YYYY-MM-DD HH:mm:ss");
            if (status == 1) {
                data.append("recieved_time", ticketDate);
            } else if (status == 2) {
                data.append("assigned_time", ticketDate);
            } else if (status == 3) {
                data.append("resolved_time", ticketDate);
            } else if (status == 4) {
                data.append("stop_time", ticketDate);
            } else if (status == 5) {
                data.append("closed_time", ticketDate);
            } else if (status == 6) {
                data.append("scheduled_time", ticketDate);
            } else if (status == 7) {
                data.append("re_scheduled_time", ticketDate);
            }

            this.props.updateTicketBySupervisor(id, data);
        }

        event.preventDefault();
    };

    handleAddEmailTo = async (email_id: any, user_id: any) => {
        this.setState({
            toEnginner: email_id,
            email_to_id: user_id,
            replyFile: "",
            replyDescription: "",
            emailRecipents: []
        });
    };

    handleCloseModal = () => {
        // 1. Reset state fields
        this.setState({ replyDescription: "", emailRecipents: [] });

        // 2. Reset file input
        if (this.fileInputRefReply) {
            this.fileInputRefReply.value = "";
        }

    };

    handleReplySaveBtnClick = () => {
        const ticket_status_code = this.props.ticket.ticket_status_code;
        const {
            toEnginner,
            replyFile,
            emailRecipents,
            replyDescription,
            emailFrom,
            email_to_id,
        } = this.state;
        const data: any = new FormData();
        const userId = sessionStorage.getItem("userId");

        const ccEmails =
            Array.isArray(emailRecipents)
                ? emailRecipents
                    .map((item: any) => {
                        if (typeof item === "string") {
                            return item;
                        }
                        // ReactTags items usually carry the email in `id`
                        if (item?.id && typeof item.id === "string") {
                            return item.id;
                        }
                        return "";
                    })
                    .filter(Boolean)
                : [];

        if (ccEmails.length > 0) {
            // Zod expects `emailRecipents` as an array of strings,
            // so we send it as a JSON-encoded array from the frontend.
            data.append("emailRecipents", JSON.stringify(ccEmails));
        }
        data.append("description", replyDescription);
        data.append("emailFrom", emailFrom);
        data.append("ticket_id", this.props.match.params.id);
        data.append("email_from_id", userId);
        data.append("emailTo", toEnginner);
        data.append("email_to_id", email_to_id);
        if (ticket_status_code) {
            data.append("ticket_status", ticket_status_code);
        }

        if (replyFile) {
            for (var x = 0; x < replyFile.length; x++) {
                data.append("files", replyFile[x]);
            }
        }
        this.props.sendReply(data);
        this.closeModal.click();
    };
    formatDuration = (minutes?: number | string | null) => {
        const value = Number(minutes);
        if (!Number.isFinite(value) || value <= 0) {
            return null;
        }
        if (value < 60) {
            return `${value} mins`;
        }
        const hours = value / 60;
        if (hours < 24) {
            return Number.isInteger(hours) ? `${hours} hrs` : `${hours.toFixed(1)} hrs`;
        }
        const days = hours / 24;
        return Number.isInteger(days) ? `${days} days` : `${days.toFixed(1)} days`;
    };

    render() {
        if (sessionStorage.token) {
            jwt.verify(
                sessionStorage.token,
                config.secretKey,
                (err: any, decoded: any) => {
                    if (err) {
                        this.props.logoutUser();
                    }
                }
            );
        } else {
            return <Redirect to="/" />;
        }

        let messcolor;
        const {
            isInserted,
            message,
            ticket,
            priority,
            subCategory,
            pausedStatus,
            resumeStatus,
            isLoad,
            status,
            supervisorStatus,
            engineerStatus,
            requester,
            engineers,
            types,
            groups,
            ticket_discussion_list,
        } = this.props;
        const { category, assignee, request, group, emailRecipents } = this.state;
        // requester_file is already an array from API
        // const requesterFiles = Array.isArray(ticket?.requester_file) ? ticket.requester_file : [];
        let requesterFiles: any[] = [];
        const raw: any = ticket?.requester_file;
        if (Array.isArray(raw)) {
            requesterFiles = raw;
        } else if (typeof raw === 'string' && raw.trim().startsWith('[')) {
            try {
                requesterFiles = JSON.parse(raw);
            } catch (e) {
                console.warn("Failed to parse requester_file JSON:", raw, e);
                requesterFiles = [];
            }
        }
        const priorityLabel = ticket?.priority_ticket_priority_description || "";
        const responseSlaLabel = this.formatDuration(ticket?.priority_response);
        const resolutionSlaLabel = this.formatDuration(ticket?.priority_resolution);

        // Assignee Data
        let userData: any = [];
        let selectedOption: any = null;
        if (engineers.length > 0) {
            engineers.forEach((element: any) => {
                var user = { value: element.id, label: element.name };
                userData.push(user);
                if (assignee && String(assignee) == String(element.id)) {
                    selectedOption = user;
                }
            });
        }

        // Requester Data
        let requesterData: any = [];
        let selectedRequester: any = null;
        if (requester.length > 0) {
            requester.forEach((element: any) => {
                var requester = { value: element.id, label: element.name };
                requesterData.push(requester);
                if (request && String(request) == String(element.id)) {
                    selectedRequester = requester;
                }
            });
        }

        // Groups Data
        let groupData: any = [];
        let selectedGroup: any = null;
        if (groups.length > 0) {
            groups.forEach((element: any) => {
                var groupp = { value: element.id, label: element.name };
                groupData.push(groupp);
                if (group && String(group) == String(element.id)) {
                    selectedGroup = groupp;
                }
            });
        }

        //Category Data
        let catData: any = [];
        let selectedCategory: any = null;
        if (types.length > 0) {
            types.forEach((element: any) => {
                var type = { value: element.id, label: element.cat_name };
                catData.push(type);
                if (category && String(category) == String(element.id)) {
                    selectedCategory = type;
                }
            });
        }

        //SubCategory Data
        let subCatData: any = [];
        let selectedSubCategory: any = null;
        if (subCategory && subCategory.length > 0) {
            subCategory.forEach((element: any) => {
                var subCat = { value: element.id, label: element.name };
                subCatData.push(subCat);
                if (this.state.subCategory && String(this.state.subCategory) == String(element.id)) {
                    selectedSubCategory = subCat;
                }
            });
        }

        if (isInserted) {
            messcolor = "green";
        } else {
            messcolor = "red";
        }

        const roleId = sessionStorage.getItem("role");

        return (
            <div className="page">
                <CheckChanges path="/edit-ticket" />
                <Topbar />
                <div className="page-content d-flex align-items-stretch">
                    <Sidebar />
                    <div className="content-inner">
                        <header className="page-header pb-1">
                            <div className="container-fluid">
                                <div className="d-flex bd-highlight py-3">
                                    <div className="mr-auto bd-highlight">
                                        <h4>Ticket Management</h4>
                                    </div>
                                </div>
                            </div>
                        </header>
                        <div className="breadcrumb-holder container-fluid">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/tickets" className="text-primary">
                                        Tickets
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active">Update Ticket</li>
                            </ul>
                        </div>
                        <section className="forms pt-3">
                            <div className="container-fluid">
                                <div className="row mt-2">
                                    <div className="col-lg-7">
                                        <div className="card">
                                            {(() => {
                                                if (ticket_discussion_list.length > 0) {
                                                    return (
                                                        <div>
                                                            {ticket_discussion_list.length > 0 &&
                                                                ticket_discussion_list.map((item, index, array) => {
                                                                    const isReassignReasonShown = (index === array.length - 1 && ticket.re_assign_reason && Object.keys(ticket.re_assign_reason).length > 0);
                                                                    // replyFile is already an array from API
                                                                    const replyFiles = Array.isArray(item.replyFile) ? item.replyFile : [];
                                                                    return (
                                                                        <>
                                                                            <div className="card-body">
                                                                                <div className="post-heading">
                                                                                    <div className="row">
                                                                                        <div className="col-11">
                                                                                            <div className="d-flex justify-content-between">
                                                                                                <div className="media">
                                                                                                    <div className="media-left">
                                                                                                        <a href="#">
                                                                                                            {item.email_from_id &&
                                                                                                                item.email_from_id.profileImage !=
                                                                                                                "undefined" ? (<img className="media-object photo-profile" src={IMAGE_URL + item.email_from_id.profileImage} width="40" height="40" alt="..." />
                                                                                                            ) : (
                                                                                                                <img className="media-object photo-profile" src={process.env.PUBLIC_URL + "/assets/img/profile_vector.png"} width="40" height="40" alt="..." />
                                                                                                            )}
                                                                                                        </a>
                                                                                                    </div>
                                                                                                    <div className="media-body pl-xl-3">
                                                                                                        <span className="comment-click anchor-username">
                                                                                                            <h6 className="m-0 media-heading">
                                                                                                                {item.email_from_id && item.email_from_id.name}
                                                                                                            </h6>
                                                                                                        </span>

                                                                                                        <p className="m-0 forum-date">
                                                                                                            {moment(item.createdAt).local().format("MMM Do YYYY | hh:mm a ")}
                                                                                                        </p>

                                                                                                        {item.email_to_id && (
                                                                                                            <div>
                                                                                                                <p className="m-0 forum-date">
                                                                                                                    <span className="text-bold">Sent to:</span>{" "}
                                                                                                                    {item.email_to_id?.name}
                                                                                                                </p>

                                                                                                                {item.emailRecipents && (() => {
                                                                                                                    let recipients: any[] = [];

                                                                                                                    if (Array.isArray(item.emailRecipents)) {
                                                                                                                        recipients = item.emailRecipents;
                                                                                                                    } else if (typeof item.emailRecipents === "string" && item.emailRecipents.trim() !== "") {
                                                                                                                        try {
                                                                                                                            const parsed = JSON.parse(item.emailRecipents);
                                                                                                                            if (Array.isArray(parsed)) {
                                                                                                                                recipients = parsed;
                                                                                                                            } else {
                                                                                                                                recipients = [item.emailRecipents];
                                                                                                                            }
                                                                                                                        } catch {
                                                                                                                            recipients = [item.emailRecipents];
                                                                                                                        }
                                                                                                                    }

                                                                                                                    const emails = recipients
                                                                                                                        .map((r: any) =>
                                                                                                                            typeof r === "string" ? r : r?.id || r?.text || ""
                                                                                                                        )
                                                                                                                        .filter(Boolean);

                                                                                                                    if (!emails.length) {
                                                                                                                        return null;
                                                                                                                    }

                                                                                                                    return (
                                                                                                                        <p className="m-0 forum-date">
                                                                                                                            <span className="text-bold">CC:</span>{" "}
                                                                                                                            {emails.join(", ")}
                                                                                                                        </p>
                                                                                                                    );
                                                                                                                })()}
                                                                                                            </div>
                                                                                                        )}
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="active-ticket-status">
                                                                                                    <span className={`p-1 rounded text-light ${item.ticket_status.ticket_status_description}`}>
                                                                                                        {item.ticket_status.ticket_status_description}
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        {(() => {
                                                                                            if (item.ticket_status != null) {
                                                                                                if (item.ticket_status.ticket_status_code == 5) {
                                                                                                    return (
                                                                                                        ''
                                                                                                    )
                                                                                                }
                                                                                                return <div className="col-md-1 text-right"> <a title="Reply" className="reply-btn" onClick={() => this.handleAddEmailTo(item.email_from_id.email, item.email_from_id.id)} data-toggle="modal" data-target="#replyModal"><i className="pl-xl-1 fa fa-reply"></i></a></div>
                                                                                            }
                                                                                        })()}
                                                                                    </div>
                                                                                </div>
                                                                                <div className="post-body pt-xl-3">
                                                                                    <div className="view ql-editor" dangerouslySetInnerHTML={{ __html: item?.description }}></div>
                                                                                    {replyFiles.length > 0 &&
                                                                                        replyFiles.map((file: any, fileIndex: number) => {
                                                                                            const fileUrl = typeof file === 'string' ? file : (file?.res ? file?.res : file?.url ? file?.url : file);
                                                                                            if (!fileUrl) return null;
                                                                                            return (
                                                                                                <p key={fileIndex}>
                                                                                                    <a
                                                                                                        href="#"
                                                                                                        onClick={(event) => {
                                                                                                            event.preventDefault();
                                                                                                            const downloadLink = `${IMAGE_URL}${fileUrl}`;
                                                                                                            window.open(downloadLink, "_blank");
                                                                                                        }}
                                                                                                        style={{ fontSize: "0.8rem" }}
                                                                                                    >
                                                                                                        Click to Open attachment
                                                                                                    </a>
                                                                                                </p>
                                                                                            );
                                                                                        })}
                                                                                </div>
                                                                                <div className="clearfix"></div>
                                                                                <div className="clear"></div>
                                                                            </div>
                                                                        </>
                                                                    )
                                                                }
                                                                )}
                                                        </div>
                                                    );
                                                } else {
                                                    return ""
                                                }
                                            })()}

                                            <div className="card-body">
                                                <div className="post-heading">
                                                    <div className="row">
                                                        <div className="col-11">
                                                            <div className="d-flex justify-content-between">
                                                                <div className="media">
                                                                    <div className="media-left">
                                                                        {ticket.requester_profileImage && ticket.requester_profileImage !== "undefined" ? (
                                                                            <img className="media-object photo-profile" src={IMAGE_URL + ticket.requester_profileImage} width="40" height="40" alt="..." />
                                                                        ) : (
                                                                            <img className="media-object photo-profile"
                                                                                src={process.env.PUBLIC_URL + "/assets/img/profile_vector.png"} width="40" height="40" alt="..." />
                                                                        )}
                                                                    </div>
                                                                    <div className="media-body pl-xl-3">
                                                                        <span className="comment-click anchor-username">
                                                                            <h6 className="m-0 media-heading">
                                                                                {ticket.requester_name}
                                                                            </h6>
                                                                        </span>
                                                                        <p className="m-0 forum-date">
                                                                            {moment(ticket.recieved_time).local().format("MMM Do YYYY | hh:mm a ")}
                                                                        </p>
                                                                        {ticket.assignee_id && (
                                                                            <p className="m-0 forum-date">
                                                                                Sent to: {ticket.assignee_name}
                                                                            </p>
                                                                        )}
                                                                        {priorityLabel && (
                                                                            <p className="m-0 forum-date">
                                                                                Priority: <span className="text-bold">{priorityLabel}</span>
                                                                                {responseSlaLabel && (
                                                                                    <span className="ml-2">
                                                                                        Response SLA: {responseSlaLabel}
                                                                                    </span>
                                                                                )}
                                                                                {resolutionSlaLabel && (
                                                                                    <span className="ml-2">
                                                                                        Resolution SLA: {resolutionSlaLabel}
                                                                                    </span>
                                                                                )}
                                                                            </p>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                {
                                                                    (ticket.status_ticket_status_description || ticket.ticket_status_description) ? (
                                                                        <div className="active-ticket-status">
                                                                            <span className={"p-1 rounded text-light " + (ticket.status_ticket_status_description || ticket.ticket_status_description)}>
                                                                                {ticket.status_ticket_status_description || ticket.ticket_status_description}
                                                                            </span>
                                                                        </div>
                                                                    ) : ''
                                                                }

                                                            </div>
                                                        </div>
                                                        {
                                                            ticket.ticket_status_code == 5 ? '' : <div className="col-md-1 text-right"> <a title="Reply" className="reply-btn" onClick={() => this.handleAddEmailTo(ticket.requester_email, ticket.requester_id)} data-toggle="modal" data-target="#replyModal" > <i className="pl-xl-1 fa fa-reply"></i></a></div>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="post-body pt-xl-3">
                                                    <Interweave content={ticket.description} />
                                                    {requesterFiles.length > 0 &&
                                                        requesterFiles.map((file: any, index: number) => {
                                                            const fileUrl =
                                                                typeof file === "string"
                                                                    ? file
                                                                    : file?.res
                                                                        ? file.res
                                                                        : file?.url
                                                                            ? file.url
                                                                            : file?.req
                                                                                ? file.req
                                                                                : "";
                                                            if (!fileUrl) return null;
                                                            return (
                                                                <p key={index}>
                                                                    <a
                                                                        href={`${IMAGE_URL}${fileUrl}`}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        style={{ fontSize: "0.8rem" }}
                                                                    >
                                                                        Click to open attachment
                                                                    </a>
                                                                </p>
                                                            );
                                                        })}
                                                </div>
                                                <div className="clearfix"></div>
                                                <div className="clear"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-5">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="form-horizontal">
                                                    <div className="row">
                                                        <div className="col">
                                                            <div className="form-group">
                                                                <label className="form-control-label font-weight-bold">
                                                                    Subject
                                                                </label>
                                                                <input id="subject" type="text" disabled name="subject" required data-msg="Please enter Ticket Name" defaultValue={ticket.subject} className="input-material input-material-disabled" onChange={this.handleInputChange} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {roleId === "5" || roleId === "3" ? (
                                                        <div className="row">
                                                            <div className="col">
                                                                <div className="form-group">
                                                                    <label className="form-control-label font-weight-bold">
                                                                        Requester Name
                                                                        <span className="text-danger">*</span>
                                                                    </label>
                                                                    <input disabled value={ticket.requester_name || ""} className="input-material input-material-disabled"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="row">
                                                            <div className="col">
                                                                <div className="form-group">
                                                                    <label className="form-control-label font-weight-bold">
                                                                        Requester Name
                                                                        <span className="text-danger">*</span>
                                                                    </label>
                                                                    <Select
                                                                        value={selectedRequester}
                                                                        closeMenuOnSelect={true}
                                                                        defaultValue={{
                                                                            label: "Select Requester",
                                                                            value: 0,
                                                                        }}
                                                                        name="requester"
                                                                        options={requesterData}
                                                                        className="basic-multi-select"
                                                                        classNamePrefix="select"
                                                                        onChange={(e: any) =>
                                                                            this.handleInputChangeRequester(e)
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {roleId === "5" || roleId === "3" ? (
                                                        <div className="row">
                                                            <div className="col">
                                                                <div className="form-group">
                                                                    <label className="form-control-label font-weight-bold">
                                                                        Assignee Group
                                                                        <span className="text-danger">*</span>
                                                                    </label>
                                                                    <input
                                                                        disabled
                                                                        value={ticket.group_name || "N/A"}
                                                                        className="input-material input-material-disabled"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="row">
                                                            <div className="col">
                                                                <div className="form-group">
                                                                    <label className="form-control-label font-weight-bold">
                                                                        Assignee Group
                                                                        <span className="text-danger">*</span>
                                                                    </label>
                                                                    <Select
                                                                        value={selectedGroup}
                                                                        closeMenuOnSelect={true}
                                                                        defaultValue={{
                                                                            label: "Select Group",
                                                                            value: 0,
                                                                        }}
                                                                        name="group"
                                                                        options={groupData}
                                                                        className="basic-multi-select"
                                                                        classNamePrefix="select"
                                                                        onChange={(e: any) =>
                                                                            this.handleInputChangeGroup(e)
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {roleId === "5" || roleId === "3" ? (
                                                        <div className="row">
                                                            <div className="col">
                                                                <div className="form-group">
                                                                    <label className="form-control-label font-weight-bold">
                                                                        Assigned To
                                                                        <span className="text-danger">*</span>
                                                                    </label>
                                                                    <input
                                                                        disabled
                                                                        value={ticket.assignee_name || "N/A"}
                                                                        className="input-material input-material-disabled"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="row">
                                                            <div className="col">
                                                                <div className="form-group">
                                                                    <label className="form-control-label font-weight-bold">
                                                                        Assigned To
                                                                        <span className="text-danger">*</span>
                                                                    </label>
                                                                    <Select
                                                                        ref={(ref) => { this.selectRef = ref; }}
                                                                        defaultValue={{ label: "Select Assignee", value: 0 }}
                                                                        value={selectedOption}
                                                                        closeMenuOnSelect={true}
                                                                        name="assignee"
                                                                        options={userData}
                                                                        className="basic-multi-select"
                                                                        classNamePrefix="select"
                                                                        onChange={this.handleAssigneeInputChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {roleId === "5" || roleId === "3" ? (
                                                        <div className="row">
                                                            <div className="col">
                                                                <div className="form-group">
                                                                    <label className="form-control-label font-weight-bold">
                                                                        Select Category
                                                                        <span className="text-danger">*</span>
                                                                    </label>
                                                                    <input
                                                                        disabled
                                                                        value={ticket.category_name || "N/A"}
                                                                        className="input-material input-material-disabled"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="row">
                                                            <div className="col">
                                                                <div className="form-group">
                                                                    <label className="form-control-label font-weight-bold">
                                                                        Select Category
                                                                        <span className="text-danger">*</span>
                                                                    </label>
                                                                    <Select
                                                                        value={selectedCategory}
                                                                        closeMenuOnSelect={true}
                                                                        defaultValue={{ label: "Select Category", value: 0 }}
                                                                        name="category"
                                                                        options={catData}
                                                                        className="basic-multi-select"
                                                                        classNamePrefix="select"
                                                                        onChange={this.handleInputChangeCategory}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {roleId === "5" || roleId === "3" ? (
                                                        <div className="row">
                                                            <div className="col">
                                                                <div className="form-group">
                                                                    <label className="form-control-label font-weight-bold">
                                                                        Select Sub Category
                                                                        <span className="text-danger">*</span>
                                                                    </label>

                                                                    <Select
                                                                        ref={(ref) => { this.selectRefCat = ref; }}
                                                                        value={selectedSubCategory}
                                                                        closeMenuOnSelect={true}
                                                                        name="subCategory"
                                                                        defaultValue={{ label: "Select Sub Category", value: 0 }}
                                                                        isClearable
                                                                        options={subCatData}
                                                                        className="input-material input-material-disabled"
                                                                        classNamePrefix="select"
                                                                        isDisabled
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="row">
                                                            <div className="col">
                                                                <div className="form-group">
                                                                    <label className="form-control-label font-weight-bold">
                                                                        Select Sub Category
                                                                        <span className="text-danger">*</span>
                                                                    </label>
                                                                    <Select
                                                                        ref={(ref) => { this.selectRefCat = ref; }}
                                                                        value={selectedSubCategory}
                                                                        closeMenuOnSelect={true}
                                                                        name="subCategory"
                                                                        defaultValue={{ label: "Select Sub Category", value: 0 }}
                                                                        isClearable
                                                                        options={subCatData}
                                                                        className="basic-multi-select"
                                                                        classNamePrefix="select"
                                                                        onChange={this.handleSubCategoryInputChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {roleId === "5" || roleId === "3" ? (
                                                        <div className="row">
                                                            <div className="col">
                                                                <div className="form-group">
                                                                    <label className="form-control-label font-weight-bold">
                                                                        Ticket Priority
                                                                        <span className="text-danger">*</span>
                                                                    </label>
                                                                    <input
                                                                        disabled
                                                                        value={ticket.ticket_priority_description || "N/A"}
                                                                        className="input-material input-material-disabled"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="row">
                                                            <div className="col">
                                                                <div className="form-group">
                                                                    <label className="form-control-label font-weight-bold">
                                                                        Ticket Priority
                                                                        <span className="text-danger">*</span>
                                                                    </label>
                                                                    <select
                                                                        name="priority"
                                                                        value={this.state.priority || ""}
                                                                        className="form-control text-capitalize mt-2"
                                                                        required
                                                                        data-msg="Please select priority"
                                                                        onChange={this.handleInputChange}
                                                                    >
                                                                        <option value="">Select Priority</option>
                                                                        {priority &&
                                                                            priority.map((p, index) => (
                                                                                <option
                                                                                    key={index}
                                                                                    value={p.ticket_priority_code}
                                                                                >
                                                                                    {p.ticket_priority_description}
                                                                                </option>
                                                                            ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {/* {ticket && ticket.ticket_status_code && (roleId === "5" || roleId === "3") && ticket.ticket_status_code === 2 && (
                                                        <div className="row">
                                                            <div className="col">
                                                                <div className="form-group">
                                                                    <label className="form-control-label font-weight-bold">
                                                                        Work Notes {(this.state.status == 5 || ticket.ticket_status_code == 2) && (<span className="text-danger">*</span>)}
                                                                    </label>
                                                                    <ReactQuill
                                                                        modules={this.myModules}
                                                                        theme="snow"
                                                                        value={this.state.work_note}
                                                                        onChange={this.handleWorkNoteChange}
                                                                        placeholder="Work note goes here..."
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )} */}
                                                    {ticket && ticket.ticket_status_code && (roleId === "5" || roleId === "3") ? (
                                                        <div className="row">
                                                            <div className="col">
                                                                <div className="form-group">
                                                                    <label className="form-control-label font-weight-bold">
                                                                        Ticket Status
                                                                        <span className="text-danger">*</span>
                                                                    </label>
                                                                    {ticket.ticket_status_code == 9 ? (
                                                                        <select
                                                                            name="status"
                                                                            value={this.state.status || ""}
                                                                            className="form-control text-capitalize mt-2"
                                                                            required
                                                                            data-msg="Please select status"
                                                                            onChange={this.handleInputChange}
                                                                        >
                                                                            <option value="">Select Status</option>
                                                                            {pausedStatus
                                                                                ? pausedStatus.map((value, index) => (
                                                                                    <option
                                                                                        key={index}
                                                                                        value={value?.ticket_status_code}
                                                                                    >
                                                                                        {value?.ticket_status_description}
                                                                                    </option>
                                                                                ))
                                                                                : engineerStatus.map((value, index) => (
                                                                                    <option
                                                                                        key={index}
                                                                                        value={value?.ticket_status_code}
                                                                                    >
                                                                                        {value?.ticket_status_description}
                                                                                    </option>
                                                                                ))}
                                                                        </select>
                                                                    ) : ticket.ticket_status_code == 4 ? (
                                                                        <select
                                                                            name="status"
                                                                            value={this.state.status || ""}
                                                                            className="form-control text-capitalize mt-2"
                                                                            required
                                                                            data-msg="Please select status"
                                                                            onChange={this.handleInputChange}
                                                                        >
                                                                            <option value="">Select Status</option>
                                                                            {resumeStatus.map((value, index) => (
                                                                                <option
                                                                                    key={index}
                                                                                    value={value?.ticket_status_code}
                                                                                >
                                                                                    {value?.ticket_status_description}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                    ) : ticket.ticket_status_code == 5 ? (
                                                                        <select className="form-control text-capitalize mt-2">
                                                                            <option value={ticket.ticket_status_code}>
                                                                                {ticket.status_ticket_status_description || ticket.ticket_status_description || ticket.ticket_status_description}
                                                                            </option>
                                                                        </select>
                                                                    ) : (
                                                                        <select
                                                                            name="status"
                                                                            value={this.state.status || ""}
                                                                            className="form-control text-capitalize mt-2"
                                                                            required
                                                                            data-msg="Please select status"
                                                                            onChange={this.handleInputChange}
                                                                        >
                                                                            <option value="">Select Status</option>
                                                                            {engineerStatus.map((value, index) => (
                                                                                <option
                                                                                    key={index}
                                                                                    value={value?.ticket_status_code}
                                                                                >
                                                                                    {value?.ticket_status_description}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : roleId === "1" ? (
                                                        <>
                                                            <div className="row">
                                                                <div className="col">
                                                                    <div className="form-group">
                                                                        <label className="form-control-label font-weight-bold">
                                                                            Current Status
                                                                        </label>
                                                                        <input
                                                                            disabled
                                                                            value={ticket.status_ticket_status_description || ticket.ticket_status_description || "N/A"}
                                                                            className="form-control text-capitalize input-material-disabled mt-2"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col">
                                                                    <div className="form-group">
                                                                        <label className="form-control-label font-weight-bold">
                                                                            Change Status
                                                                            <span className="text-danger">*</span>
                                                                        </label>
                                                                        <select
                                                                            name="status"
                                                                            value={this.state.status || ""}
                                                                            className="form-control text-capitalize mt-2"
                                                                            required
                                                                            data-msg="Please select status"
                                                                            onChange={this.handleInputChange}
                                                                        >
                                                                            <option value="">Select Status</option>
                                                                            {ticket.ticket_status_code == 1
                                                                                ? supervisorStatus.map((value, index) => (
                                                                                    <option
                                                                                        key={index}
                                                                                        value={value?.ticket_status_code}
                                                                                    >
                                                                                        {value?.ticket_status_description}
                                                                                    </option>
                                                                                ))
                                                                                : (ticket.ticket_status_code == 2 || ticket.ticket_status_code == 9)
                                                                                    ? engineerStatus.map((value, index) => (
                                                                                        <option
                                                                                            key={index}
                                                                                            value={value?.ticket_status_code}
                                                                                        >
                                                                                            {value?.ticket_status_description}
                                                                                        </option>
                                                                                    ))
                                                                                    : ticket.ticket_status_code == 4
                                                                                        ? resumeStatus.map((value, index) => (
                                                                                            <option
                                                                                                key={index}
                                                                                                value={value?.ticket_status_code}
                                                                                            >
                                                                                                {value?.ticket_status_description}
                                                                                            </option>
                                                                                        ))
                                                                                        : null
                                                                            }
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div className="row">
                                                                <div className="col">
                                                                    <div className="form-group">
                                                                        <label className="form-control-label font-weight-bold">
                                                                            Current Status
                                                                        </label>
                                                                        <input
                                                                            disabled
                                                                            value={ticket.status_ticket_status_description || ticket.ticket_status_description || "N/A"}
                                                                            className="form-control text-capitalize input-material-disabled mt-2"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col">
                                                                    <div className="form-group">
                                                                        <label className="form-control-label font-weight-bold">
                                                                            Change Status
                                                                            <span className="text-danger">*</span>
                                                                        </label>
                                                                        <select
                                                                            name="status"
                                                                            value={this.state.status || ""}
                                                                            className="form-control text-capitalize mt-2"
                                                                            required
                                                                            data-msg="Please select status"
                                                                            onChange={this.handleInputChange}
                                                                        >
                                                                            <option value="">Select Status</option>
                                                                            {supervisorStatus.map((value, index) => (
                                                                                <option
                                                                                    key={index}
                                                                                    value={value.ticket_status_code}
                                                                                >
                                                                                    {value.ticket_status_description}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                                {isLoad ? (
                                                    <Loader
                                                        style={{ display: "block" }}
                                                        type="ThreeDots"
                                                        color="#00BFFF"
                                                        height={50}
                                                        width={50}
                                                    />
                                                ) : (
                                                    roleId != "3" &&
                                                    ticket.ticket_status_code !== 5 &&
                                                    ticket.ticket_status_code !== 4 && (
                                                        <div className="form-group mt-3">
                                                            <button
                                                                className="btn btn-primary"
                                                                disabled={!this.isTicketReady()}
                                                                onClick={this.handleSaveBtnClick}
                                                            >
                                                                Update Ticket
                                                            </button>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <div id="requesterAttachment" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" className="modal fade text-left">
                            <div role="document" className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h4 id="exampleModalLabel" className="modal-title">
                                            Requester Attachment
                                        </h4>
                                        <button type="button" data-dismiss="modal" aria-label="Close" className="close">
                                            <span aria-hidden="true">Ã—</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
                {/* Reply From Requester */}
                <div id="replyModal" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" className="modal fade text-left" data-backdrop="static" data-keyboard="false"  >
                    <div role="document" className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 id="exampleModalLabel" className="modal-title">
                                    Reply
                                </h4>
                                <button type="button" data-dismiss="modal" aria-label="Close" className="close" onClick={this.handleCloseModal}  >
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="form-horizontal">
                                    <div className="row">
                                        <div className="col">
                                            <div className="form-group">
                                                <label className="form-control-label font-weight-bold">
                                                    To<span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    id="toEnginner"
                                                    type="text"
                                                    disabled
                                                    name="toEnginner"
                                                    required
                                                    data-msg="Please enter Email"
                                                    defaultValue={this.state.toEnginner}
                                                    className="input-material input-material-disabled"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <div className="form-group">
                                                <label className="form-control-label font-weight-bold">
                                                    CC
                                                </label>
                                                <div>
                                                    <ReactTags
                                                        placeholder="Press enter to add email."
                                                        tags={emailRecipents}
                                                        suggestions={[]}
                                                        handleDelete={this.handleDeleteTag}
                                                        handleAddition={this.handleAdditionTag}
                                                        handleDrag={this.handleDragTag}
                                                        delimiters={delimiters}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <div className="form-group">
                                                <label className="form-control-label font-weight-bold">
                                                    Description<span className="text-danger">*</span>
                                                </label>
                                                <ReactQuill
                                                    modules={this.myModules}
                                                    theme="snow"
                                                    value={this.state.replyDescription}
                                                    onChange={this.handleReactQuillChange}
                                                    placeholder="Description goes here..."
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <div className="form-group">
                                                <label className="form-control-label font-weight-bold">
                                                    Select Attachment
                                                </label>
                                                <input
                                                    id="files"
                                                    type="file"
                                                    name="file"
                                                    ref={(ref) => { this.fileInputRefReply = ref; }}
                                                    multiple
                                                    className="btn btn-primary form-control-file"
                                                    onChange={this.fileSelectedHandlerReply}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    ref={(el) => (this.closeModal = el)}
                                    data-dismiss="modal"
                                    className="btn btn-secondary"
                                    onClick={this.handleCloseModal}
                                >
                                    Close
                                </button>
                                <button
                                    className="btn btn-primary"
                                    disabled={!this.isReplyReady()}
                                    onClick={this.handleReplySaveBtnClick}
                                >
                                    Send
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        ticket: state.ticket.ticket,
        priority: state.ticket.priority,
        status: state.ticket.status,
        supervisorStatus: state.ticket.supervisorStatus,
        engineerStatus: state.ticket.engineerStatus,
        pausedStatus: state.ticket.pausedStatus,
        resumeStatus: state.ticket.resumeStatus,
        types: state.ticket.types,
        subCategory: state.ticket.subCategory,
        engineers: state.ticket.engineers,
        groups: state.ticket.groups,
        requester: state.ticket.requester,
        message: state.ticket.message,
        isInserted: state.ticket.isInserted,
        ticket_discussion_list: state.ticket.ticket_discussion_list,
        isLoad: state.ticket.isLoad,
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        updateTicketBySupervisor: function (id: any, data: any) {
            dispatch(updateTicketBySupervisor(id, data));
        },
        updateTicketByEngineer: function (id: any, data: any) {
            dispatch(updateTicketByEngineer(id, data));
        },
        sendReply: function (data: any) {
            dispatch(sendReply(data));
        },
        priorityList: function () {
            dispatch(priorityList());
        },
        statusList: function () {
            dispatch(statusList());
        },
        groupList: function () {
            dispatch(groupList());
        },
        requestersList: function () {
            dispatch(requestersList());
        },
        getTicket: function (id: any) {
            dispatch(getTicket(id));
        },
        getAllTicketDiscussionByTicket: function (id: any) {
            dispatch(getAllTicketDiscussionByTicket(id));
        },
        typeList: function () {
            dispatch(typeList());
        },
        subCategoryList: function (id: any) {
            dispatch(subCategoryList(id));
        },
        engineersList: function (id: any) {
            dispatch(engineersList(id));
        },
        engineersListByRole: function (id: any) {
            dispatch(engineersListByRole(id));
        },
        logoutUser: function () {
            dispatch(logoutUser());
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditTicket);